module.exports = __webpack_public_path__ + "b8f9b767c9683c442b16dc867b859fe1.png";